// extracted by mini-css-extract-plugin
module.exports = {"AnchorLink":"InnerLink-module__AnchorLink___1RBh9","anchorLink":"InnerLink-module__AnchorLink___1RBh9"};